import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-blog-desktop',
  templateUrl: './blog-desktop.component.html',
  styleUrls: ['./blog-desktop.component.css']
})
export class BlogDesktopComponent implements OnInit {

  raw6xgs: string = ' '
  rawdry2: string = ' '
  rawaj3p: string = ' '
  raw4kat: string = ' '
  rawig9s: string = ' '
  constructor(private title: Title, private meta: Meta) {
    this.title.setTitle('Blog - Blue Assist')
    this.meta.addTags([
      {
        property: 'og:title',
        content: 'Blog - Blue Assist',
      },
    ])
  }

  ngOnInit() {
  }

}
